import UnlinkedTransferAccountsPage from "components/pages/UnlinkedTransferAccountsPage";

/**
 * @name CaptureCrossAccountMain
 * @returns {React.Component}
 * @description 
 * This capture is used in the following capture groups:
 * "Unlinked Accounts" (abi22).
 */
export default function CaptureCrossAccountMain(props) {
    return <UnlinkedTransferAccountsPage />;
}